import { atom } from "@reatom/framework";

export const userAtom = atom<number | null>(null, "userAtom");
